import { render, staticRenderFns } from "./postponeClassHours.vue?vue&type=template&id=2daee28c&"
import script from "./postponeClassHours.vue?vue&type=script&lang=js&"
export * from "./postponeClassHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports